<template>
  <div>
    <div id="map-canvas" hidden="true"></div>
    <!-- <router-view/> -->
    <keep-alive include="bulletinBoard" v-if="isLogin"><router-view/></keep-alive>
    <router-view v-else/>
  </div>
</template>

<script>
    // @ is an alias to /src
    import { SET_WINDOWWIDTH } from './store/actions/otherConst'
    import { USER_REQUEST } from './store/actions/userConst'
    import { GET_SKILLS,GET_ARTIST_TYPES } from './store/actions/skillsConst'
    import { mapActions,mapGetters } from 'vuex'

    export default {
      created() {
        this.USER_REQUEST()
          .then((resp)=>console.log(resp))
          .catch((err)=>console.log(err))
        this.GET_SKILLS()
          .then((resp)=>console.log(resp))
          .catch((err)=>console.log(err))
        this.GET_ARTIST_TYPES()
          .then((resp)=>console.log(resp))
          .catch((err)=>console.log(err))
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
      },
      beforeDestroy: function () {
        window.removeEventListener('resize', this.handleResize)
      },
      computed: {
        ...mapGetters(['isLogin']),
      },
      methods: {
        ...mapActions([USER_REQUEST,GET_SKILLS,GET_ARTIST_TYPES]),
        handleResize() {
          this.$store.dispatch(SET_WINDOWWIDTH, document.documentElement.clientWidth);
        },
      },
    }
</script>

<style>
  .pac-container {
      z-index: 1051 !important;
  }
  [v-cloak] { 
    display: none !important; 
  }
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    margin-top: 60px;
  }
  .disable-col-padding {
        padding-left: 0 !important;
        padding-right: 0 !important;
  }
  .disable-col-padding-l {
        padding-left: 0 !important;
  }
  .disable-col-padding-r {
        padding-right: 0 !important;
  }
  ::-webkit-scrollbar {
    width: 12px
  }
  ::-webkit-scrollbar-track {
      box-shadow: inset 0 0 5px transparent
  }
  ::-webkit-scrollbar-thumb {
      background: #dd4242;
      border-radius: 5px
  }
  ::-webkit-scrollbar-thumb:hover {
      background: #df2f2f;
  }
  .hidden-md {
      display: none !important;
  }
  input[type=radio],
  input[type=checkbox] { 
    display:none; 
    } /* to hide the checkbox itself */
  input[type=radio] + label:before,
  input[type=checkbox] + label:before {
    font-family: FontAwesome;
    display: inline-block;
  }

  input[type=radio] + label:before,
  input[type=checkbox] + label:before { 
      content: "\f096"; 
      padding-left: 2px;
      transition: all 1s;
    } /* unchecked icon */
  input[type=radio] + label:before,
  input[type=checkbox] + label:before {
      letter-spacing: 10px; 
    } /* space between checkbox and label */
  input[type=radio]:checked + label:before,
  input[type=checkbox]:checked + label:before {
      content: "\f046";
    } /* checked icon */
  input[type=radio]:checked + label:before,
  input[type=checkbox]:checked + label:before {
    letter-spacing: 5px;
    color: #007bff;
    } /* allow space for check mark */

  .vdp-datepicker > div > input {
    background-color: #fff !important;
    border-radius: 4px !important;
    font-size: .975rem !important;
    color: #565656 !important;
    padding: 8px 12px !important;
    height: 40px !important;
    -webkit-box-shadow: none !important;
    box-shadow: none !important;
    width: 100%;
    border: 1px solid #ced4da;
  }
  .sweet-modal {
    width: 240px !important;
  }
  .sweet-modal i.fa-check {
      color: #47cf73 !important;
      padding-right: 5px;
  }
  .sweet-modal i.fa-times {
      color: #dd0000 !important;
      padding-right: 5px;
  }
  .sweet-modal i.fa-exclamation {
      color: #dd0000 !important;
      padding-right: 10px;
      position: relative;
      top: 12px;
  }
  .sweet-modal i.fa-exclamation-circle {
      color: #dd0000 !important;
      padding-right: 10px;
      position: relative;
      top: 12px;
  }
  .sweet-modal i.fa-star-o {
    color: red !important;
    padding-right: 5px;
    padding-top: 13px;
  }
  .btn-two {
  margin: 0;
  padding: 0;
  border-width: 0;
  border-color: rgb(251, 64, 75);
  background-color: white !important;
  color: rgb(251, 64, 75);
  cursor: pointer;
  position: relative;
  font-weight: 500;
  font-family: inherit;
  padding: 5px 12px;
  z-index: 0;
  overflow: hidden;
  border-width: 2px;
  border-radius: 100px;
  -webkit-transition: color 0.3s cubic-bezier(0.02, 0.01, 0.47, 1), border-color 0.3s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: color 0.3s cubic-bezier(0.02, 0.01, 0.47, 1), border-color 0.3s cubic-bezier(0.02, 0.01, 0.47, 1);
  min-width: 200px;
  font-weight: bold;
}

.btn-two:before {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 120%;
  background: rgb(252, 101, 111);
  content: '';
  opacity: 0;
  z-index: -1;
  -webkit-transition: opacity 0.15s cubic-bezier(0.02, 0.01, 0.47, 1), -webkit-transform 0.15s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: opacity 0.15s cubic-bezier(0.02, 0.01, 0.47, 1), -webkit-transform 0.15s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: transform 0.15s cubic-bezier(0.02, 0.01, 0.47, 1), opacity 0.15s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: transform 0.15s cubic-bezier(0.02, 0.01, 0.47, 1), opacity 0.15s cubic-bezier(0.02, 0.01, 0.47, 1), -webkit-transform 0.15s cubic-bezier(0.02, 0.01, 0.47, 1);
  -webkit-transform: translate3d(-110%, -10%, 0) skewX(-20deg);
          transform: translate3d(-110%, -10%, 0) skewX(-20deg);
}

.btn-two:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 120%;
  background: rgb(251, 64, 75);
  content: '';
  opacity: 0;
  z-index: -1;
  -webkit-transition: opacity 0.15s cubic-bezier(0.02, 0.01, 0.47, 1), -webkit-transform 0.15s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: opacity 0.15s cubic-bezier(0.02, 0.01, 0.47, 1), -webkit-transform 0.15s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: transform 0.15s cubic-bezier(0.02, 0.01, 0.47, 1), opacity 0.15s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: transform 0.15s cubic-bezier(0.02, 0.01, 0.47, 1), opacity 0.15s cubic-bezier(0.02, 0.01, 0.47, 1), -webkit-transform 0.15s cubic-bezier(0.02, 0.01, 0.47, 1);
  -webkit-transform: translate3d(110%, -10%, 0) skewX(-20deg);
          transform: translate3d(110%, -10%, 0) skewX(-20deg);
}

.btn-two:hover,
.btn-two:focus {
  box-shadow: 0 1px 8px rgba(58,51,53,0.3);
  color: white;
  -webkit-transition: all 0.5s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: all 0.5s cubic-bezier(0.02, 0.01, 0.47, 1);
}

.btn-two:hover:before,
.btn-two:focus:before {
  opacity: 1;
  -webkit-transition: opacity 0.25s cubic-bezier(0.02, 0.01, 0.47, 1), -webkit-transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: opacity 0.25s cubic-bezier(0.02, 0.01, 0.47, 1), -webkit-transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1), opacity 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1), opacity 0.25s cubic-bezier(0.02, 0.01, 0.47, 1), -webkit-transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  -webkit-transform: translate3d(-50%, -10%, 0) skewX(-20deg);
          transform: translate3d(-50%, -10%, 0) skewX(-20deg);
}

.btn-two:hover:after,
.btn-two:focus:after {
  opacity: 1;
  -webkit-transition: opacity 0.25s cubic-bezier(0.02, 0.01, 0.47, 1), -webkit-transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: opacity 0.25s cubic-bezier(0.02, 0.01, 0.47, 1), -webkit-transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1), opacity 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  transition: transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1), opacity 0.25s cubic-bezier(0.02, 0.01, 0.47, 1), -webkit-transform 0.25s cubic-bezier(0.02, 0.01, 0.47, 1);
  -webkit-transform: translate3d(50%, -10%, 0) skewX(-20deg);
          transform: translate3d(50%, -10%, 0) skewX(-20deg);
}

.btn-two.btn-primary {
  border: 2px solid #007bff;
  color: #1d89ff;
}

.btn-two.btn-primary:hover,
.btn-two.btn-primary:focus {
  background: #1d89ff;
  color: #fff;
}

.btn-two.btn-primary:before {
  background: #0069d9;
}

.btn-two.btn-primary:after {
  background: #1d89ff;
}
.subscription p {
    font-size: 1.1rem;
    font-weight: 500;
}
.subscription button,
.reg-modal button {
    text-transform: uppercase;
    font-weight: 500;
}
.reg-modal .form-group.has-label {
  margin-bottom: 0 !important;
}
.btn-rounded {
    border-radius: 100px !important;
    padding-left: 20px !important;
    padding-right: 20px !important;
    padding-top: 3px !important;
    font-weight: 500 !important;
    height: 33px !important;
}
.height-auto {
    min-height: 33px !important;
    height: auto !important;
}
.btn-upload-gallery {
    margin-top: 15px;
}
.visible-xs {
    display: none !important;
}
.force-left {
  float: left;
}
.force-right {
  float: right;
}
.btn-filter {
  width: 100%;
  margin: 0px;
  font-weight: 600 !important;
  font-size: 14px !important;
  /* height: 38px; */
  text-transform: uppercase;
  border: 1px solid #FB404B !important;
  color: #FB404B !important;
}
.btn-filter:hover {
  background-color: #FB404B !important;
  border-color: #FB404B !important;
  color: #fff !important;
}
.btn-filter-alt {
  border: 1px solid #007bff !important;
  color: #007bff !important;
}
.btn-filter-alt:hover {
  border: 1px solid #007bff !important;
  background-color: #007bff !important;
  color: #fff !important;
}
.btn-filter-alt:focus,
.btn-filter-alt:active {
  border: 1px solid #007bff !important;
  box-shadow: none !important;
}
.btn-filter-i {
  background-color: #FB404B !important;
  border-color: #FB404B !important;
  color: #fff !important;
}
.btn-filter-i:hover {
  background-color: rgb(253, 36, 50) !important;
  border-color: rgb(253, 36, 50) !important;
}
.btn-filter-alt-i {
  background-color: #007bff !important;
  border-color: #007bff !important;
  color: #fff !important;
}
.btn-filter-alt-i:hover {
  background-color: #007bffe7 !important;
  border-color: #007bffe7 !important;
}
.btn-filter-w {
  background-color: transparent !important;
  width: auto !important;
  border-color: white !important;
  color: white !important;
  text-shadow: 1px 1px 1px #0000007a !important;
}
.btn-filter-w:hover {
  background-color: transparent !important;
  width: auto !important;
  border-color: white !important;
  transform: scale(1.02);
  color: white !important;
}
.padding-15 {
  padding-left: 15px;
  padding-right: 15px;
}
.sync-loader {
  margin-top: 50px;
}

  @media only screen and (max-width: 768px) {
    ::-webkit-scrollbar {
      width: 8px
    }
    .hidden-xs {
      display: none !important;
    }
    .visible-xs {
      display: block !important;
    }
    .disable-col-padding-m {
        padding-left: 0 !important;
        padding-right: 0 !important;
    }
    .disable-col-padding-l-m {
        padding-left: 0 !important;
    }
    .disable-col-padding-r-m {
        padding-right: 0 !important;
    }
    .enable-col-padding-m {
        padding-left: 15px !important;
        padding-right: 15px !important;
    }
    .enable-col-padding-l-m {
        padding-left: 15px !important;
    }
    .enable-col-padding-r-m {
        padding-right: 15px !important;
    }
    .mobile-container {
      padding-left: 5px !important;
      padding-right: 5px !important;
    }
    .visible-xs {
      display: block !important;
    }
    .content-m {
      padding-left: 0 !important;
      padding-right: 0 !important;
    }
  }

  @media only screen and (max-width: 768px) {
    .rating-tab .nav-tabs .nav-link, .nav-tabs .nav-item.show .nav-link {
        padding-left: 8px;
        padding-right: 8px;
        font-size: 0.8rem !important;
    }
  }
</style>
